import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { getControl } from '@shared/helpers/form.helper';
import { formPaths } from '@shared/constants/form-paths.const';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { toNum } from '@shared/helpers/math.helper';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../../models/interfaces/revisione.interface';
import { getCoopGaranziaFidiControl } from '../validators/helpers/coop-garanzia-fidi-form.helpers';
import { cloneDeep } from 'lodash-es';

export const setCoopGaranziaFidiSpecificListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    setFidiCkPatrNettoPerFidiListener(form, store);
    setFidiCkCapSocPerFidiListener(form, store);
};

/** Updates my_CkPatrNettoPerFidi based on my_ImportoPatrSecondoEs when fidi section is active. */
const setFidiCkPatrNettoPerFidiListener = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getControl(form, `${formPaths.bilancio}.my_ImportoPatrSecondoEs`);
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((importoPatr) => {
        if (getCoopGaranziaFidiControl(form, 'my_ScCoopFidiObbl').value !== '1') return;
        const ckValue = toNum(importoPatr) < 250_000 ? '0' : '1';
        getCoopGaranziaFidiControl(form, 'my_CkPatrNettoPerFidi').setValue(ckValue, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopFidi.my_CkPatrNettoPerFidi = ckValue;
            return myVerbaleClone;
        });
    });
};

/** Updates my_CkCapSocPerFidi based on my_CapSocSottoscrSecondoEs when fidi section is active. */
const setFidiCkCapSocPerFidiListener = (form: FormGroup, store: Store<Revisione53State>): void => {
    const control = getControl(form, `${formPaths.bilancio}.my_CapSocSottoscrSecondoEs`);
    control.valueChanges.pipe(withInitialValueDebounced(control)).subscribe((capSoc) => {
        if (getCoopGaranziaFidiControl(form, 'my_ScCoopFidiObbl').value !== '1') return;
        const ckValue = toNum(capSoc) < 100_000 ? '0' : '1';
        getCoopGaranziaFidiControl(form, 'my_CkCapSocPerFidi').setValue(ckValue, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_SezioneI__Rilevazione.my_SchedaCoopFidi.my_CkCapSocPerFidi = ckValue;
            return myVerbaleClone;
        });
    });
};
